<template>
  <div class="blacksmith-content">
    <div class="blacksmith-title">
      <div style="font-size: 14px;color: #333333">勐绿小铁匠</div>
      <div style='cursor: pointer;color: #959595;font-size: 12px' @click="moreProject">更多</div>
    </div>
    <video
        muted="muted"
        style="margin: 0 15px;width: calc(100% - 30px)"
        height="260px"
        preload="metadata"
        :src="videoUrl"
        controls="controls">
    </video>
    <div class="void-content">
      <i @click="caretLeft" class="el-icon-caret-left caret-cursor"></i>
      <div class="video-content">
        <div class="video-carousel">
          <div class="move-content">
            <div v-if="index <= 2" @click="switchVideo(index)" v-for="(item,index) in videoDataL" class="move-content-item">
              <el-image style="width: 100%;height: 100%" :src="item.imgUrl"></el-image>
            </div>
          </div>
        </div>
      </div>
      <i @click="caretRight" class="el-icon-caret-right caret-cursor"></i>
    </div>
  </div>
</template>

<script>
// import voidUrl from "../../assets/void/zsjs.MP4";
export default {
  name: "blacksmith",
  data() {
    return {
      videoDataL:[],
      videoUrl:"",
      right:0,
      fileList:[]
    };
  },
  mounted() {
    this.getVideo()
    // this.$refs.video.src = voidUrl;
  },
  methods:{
    async getVideo() {
      this.videoDataL = []
      let record = {
        fields: {TYPE_: "xtj"}
      }
      await this.$axios.post('/api/dftdstore/api/de/record/list?entityName=LOGIN_VIDEO_CONFIG',record).then((res) => {
        if (res.data.success) {
          let data = JSON.parse(JSON.stringify(res.data.rows))
          for (let i = 0; i < data.length;i++) {
            if (data[i].fields.PBLISH_HOME_PAGE === '1') {
              data[i].fields.url = data[i].fields.URL_
              this.videoDataL.push(data[i].fields)
            }
          }
        }
      })
      if (this.videoDataL.length > 0) {
        this.videoDataL.forEach((item1,index1) => {
          this.getFilesSearch(item1)
        })
        this.videoUrl = this.videoDataL[0].url
      }
      console.log(this.videoDataL,'tm123');
    },
    // 获取附件
    getFilesSearch(row) {
      // let host = window.location.host;
      this.$axios.post(`/api/fs/files/search?metaData.formId=${row.ID_}&metaData.fileType=thumbnail`).then(res => {
        if (res.status === 200) {
          res.data.forEach((item, index) => {
            item.name = item.filename
            item.url = `/api/fs/files/download/${item.id}`
          })
          this.$set(row,'imgUrl',res.data[0].url)
          row.imgUrl = res.data[0].url
        }
      });
    },
    moreProject() {
      window.open('/generalBusiness/playVideo')
    },
    // 往左侧滚动
    caretRight() {
      // 把数组的第一个放到最后一个
      let [first, ...rest] = this.videoDataL;
      this.videoDataL = [...rest, first]
      this.videoUrl = this.videoDataL[0].url
    },
    caretLeft() {
      // 把数组的最后一位放到第一个
      this.videoDataL.splice(0, 0, this.videoDataL[this.videoDataL.length - 1])
      this.videoDataL.pop()
      this.videoUrl = this.videoDataL[0].url
    },
    switchVideo(index) {
      this.videoUrl = this.videoDataL[index].url
    }
  }
}
</script>

<style scoped>
.blacksmith-content {
  width: 35%;
  height: 100%;
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
  border: 1px solid #eaeaea;
  margin: 0 12px 0 6px;
  position: relative;
}
.blacksmith-title {
  margin: 0 15px;
  height: 64px;
  font-weight: 600;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
video {
  background-color: black;
  overflow:hidden;
}
.video-content-item {
  width: 100%;
  height: 100%;
}
/deep/ .el-carousel__indicators--horizontal {
  display: none;
}
.void-content {
  width: 100%;
  height: calc(100% - 364px);
  padding: 20px 25px;
  box-sizing: border-box;
  background-color: #f4f4f4;
  display: flex;
  justify-content: center;
  align-items: center;
  /*position: absolute;*/
  margin: 20px 0;
}
.video-content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-carousel {
  position: relative;
  height: 100%;
  width: 100%;
  margin: 0 5px;
}
.move-content {
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.move-content-item {
  width: 100%;
  height: 100%;
  margin-left: 10px;
  background-color: red;
  border: 2px solid #c3c8cb;
  box-sizing:inherit;
}
.move-content-item:hover {
  border: 2px solid red;
  cursor: pointer;
}
.move-content-item:nth-child(1) {
  margin-left: 0;
}

.caret-cursor {
  font-size: 20px;
}
.caret-cursor:hover {
  color: #409EFF;
  cursor: pointer;
}
.out-box {
  position: relative;
  height: 300px;
  width: 100%;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/modularMain/blacksmith.vue